const hasProtocol = (href: string): boolean => {
  // Matches mail links (`mailto:user@example.com`) and phone links (`tel:+123456789`).
  if (/^(mailto:|tel:)/i.test(href)) {
    return true
  }

  // Matches URLs with an explicit scheme and authority, e.g. `https://example.com`.
  if (/^[a-zA-Z][a-zA-Z\d+.-]*:\/\//.test(href)) {
    return true
  }

  // Matches host/domain followed by a numeric port (`example.com:8443[/...]`) and treats it as scheme-less.
  if (/^[^/\s]+:\d+(?:[/?#]|$)/.test(href)) {
    return false
  }

  // Fallback: matches any URI-like scheme prefix ending with `:`, e.g. `javascript:`, `ftp:`, etc.
  return /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(href)
}

export const normalizeHref = (href: string): string => {
  const trimmedHref = href.trim()

  if (!trimmedHref || hasProtocol(trimmedHref)) {
    return trimmedHref
  }

  return `https://${trimmedHref}`
}

export const isValidHref = (href: string): boolean => {
  const normalizedHref = normalizeHref(href)

  if (!normalizedHref) {
    return false
  }

  if (normalizedHref.startsWith('mailto:')) {
    // Validates the email portion after `mailto:` as `local@domain.tld` with no spaces.
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedHref.slice('mailto:'.length))
  }

  try {
    const parsedHref = new URL(normalizedHref)
    return ['http:', 'https:', 'mailto:', 'tel:'].includes(parsedHref.protocol)
  } catch {
    return false
  }
}
